// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}

ion-modal {
  --width: 290px;
  --height: 400px;
  --border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/proposals/modals/create-comment/create-comment.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;;AACA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AAEJ","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n}\nion-modal {\n    --width: 290px;\n    --height: 400px;\n    --border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
